(ns frontend.view.kpi-reporting.kpi-categories.events
  (:require
   [clojure.string :as string]
   [potpuri.core :as potpuri :refer [fn-> fn->>]]
   [frontend.view.kpi-reporting.kpi-categories.db :as db]
   [frontend.view.kpi-reporting.kpi-company-reports.events :as report-events]
   [common.localization :as loc]
   [frontend.utils :as fu]
   [common.kpis :as kpis]
   [common.util :as cu]
   [promesa.core :as p]
   [frontend.actions.entity :as entity-actions]
   [frontend.actions.kpi-category :as kpi-category-actions]
   [frontend.routing :as routing]
   [frontend.analytics :as analytics]
   [frontend.state.current-session :as session]
   [frontend.view.modals.curtains.kpi-member-curtain.view :as kpi-member-curtain]
   [frontend.view.modals.curtains.settings-curtain.view :as settings-curtain]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.exports.excel :as excel]
   [frontend.conn :as conn]
   [frontend.logging :as logging]
   [frontend.view.error-utils :as error-utils]))

(defn get-wip-category
  []
  (let [kpi-category (->> @session/all-kpi-categories
                          (remove :common/disabled?)
                          (remove (fn-> :kpi-category/status (= :kpi-category.status/finished)))
                          first)]
    kpi-category))

(defn blank->nil
  [val]
  (when-not (string/blank? val)
    val))

(defn update-category!
  [category k v]
  (let [id (:db/id category)
        old-val (-> category
                    k)]
    (if (or (nil? v) (= (blank->nil v) old-val))
      (swap! db/state potpuri/dissoc-in [:edit-category id k]) ;;prevent unnecessary saving
      (swap! db/state assoc-in [:edit-category id k] v))))

(defn save-category!
  [category k v on-success! on-error!]
  (let [id (:db/id category)]
    (-> (conn/sendp! :kpi-category/update
                     {:db/id id
                      k      v})
        (p/then (fn [_]
                  (when (fn? on-success!)
                    (on-success!))
                  #_(end-edit! template-id)))
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! :template))
                   (when (fn? on-error!)
                     (on-error!))
                   (logging/error "Unable to edit kpi-category" e))))))

(defn toggle-kpi!
  [category kw enable?]
  (let [op (if enable?
             :kpi-category/add-kpi
             :kpi-category/remove-kpi)]
    (-> (conn/sendp! op
                     {:kpi-category-id (:db/id category)
                      :kpi/kw kw})
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! :kpi)) ;;TODO alerts
                   (logging/error "Unable to toggle kpi" e))))))

(def curtain-opts
  {:quantitative {:all        fu/all-kpis
                  :entity-key :kpi-category/kpis}
   :qualitative  {:all        fu/all-kpi-questions
                  :entity-key :kpi-category/questions}})

(defn open-kpi-curtain
  [type category]
  (let [{:keys [all entity-key]} (get curtain-opts type)]
    (modals/open-modal!
     settings-curtain/modal-key
     {:header-text   (loc/tr :select-kpis)
      :boolean-mode? true
      :options       {true  [:span.label-sm (loc/tr :in-use)]
                      false [:span.label-sm (loc/tr :not-used)]}
      :state         db/session
      :fields-getter (fn [state]
                       (->> (all)
                            (map (fn [{:keys [kw type visible? skip-sort?]}]
                                   {:field/name  (loc/tr kw)
                                    :field/value (-> state
                                                     :entities
                                                     (get (:db/id category))
                                                     (get entity-key)
                                                     set
                                                     (contains? kw))
                                    :field/key   kw
                                    :skip-sort?  skip-sort?}))
                            (sort (fn [a b]
                                    (let [a-not-sorted? (:skip-sort? a)
                                          b-not-sorted? (:skip-sort? b)]
                                      (cond (and a-not-sorted? b-not-sorted?) 0
                                            a-not-sorted? 1
                                            b-not-sorted? -1
                                            :else
                                            (compare (:field/name a) (:field/name b))))))
                            vec))
      :on-change!    (fn [k v]
                       (toggle-kpi! category k v))})))

(defn end-guidance-edit!
  [category kw]
  (swap! db/state update-in [:guidances (:db/id category)] dissoc kw))

(defn update-guidance!
  [category kw text]
  (swap! db/state update-in [:guidances (:db/id category)] assoc kw text))

(defn save-guidance!
  [category kw]
  (let [guidance (-> @db/state
                     :guidances
                     (get (:db/id category))
                     kw)]
    (-> (conn/sendp! :kpi-category/update-user-guidance
                     {:category-id (:db/id category)
                      :kw          kw
                      :guidance    guidance})
        (p/then (fn [_]
                  (end-guidance-edit! category kw)))
        (p/catch (fn [e]
                   #_(->> e
                          ex-data
                          :message
                          loc/tr
                          (set-alert! (if (= (namespace kw) "kpi-q-kw")
                                        :questions
                                        :kpis)))
                   (logging/error "Unable to save use guidance" e))))))

;;array 'ordering', element of index 'old' being dragged to index 'new'
(defn reorder!
  [type category ordering old new]
  (let [old-v (nth ordering old)
        new-a (if (<= old new)
                (concat (subvec ordering 0 old)
                        (subvec ordering (inc old) (inc new))
                        [old-v]
                        (nthrest ordering (inc new)))
                (concat (subvec ordering 0 new)
                        [old-v]
                        (subvec ordering new old)
                        (nthrest ordering (inc old))))]
    ;; save new ordering to local state to hide backend delay
    (swap! db/ordering assoc type new-a)
    (when-not (= old new)
      (-> (conn/sendp! :kpi-category/reorder
                       {:category-id (:db/id category)
                        :type        type
                        :ordering    new-a})
          (p/then (fn [_]
                    ;;set a timer that empties local state
                    ;; (so that subscription updates are reflected in frontend)
                    (let [old-timer @db/timer]
                      (when old-timer
                        (js/clearTimeout old-timer))
                      (reset! db/timer
                        (js/setTimeout (fn [_]
                                         (swap! db/ordering dissoc type)
                                         (reset! db/timer nil))
                                       2000)))))
          (p/catch (fn [e]
                     (swap! db/ordering dissoc type)
                     (logging/error "Unable to save kpi-category ordering" e)))))))

(defn new-separator-kw
  [type ordering]
  (let [separator-nums (->> ordering
                            (filter cu/separator-kw?)
                            (map (fn-> name (subs 1) js/parseInt)))
        sep (if (= type :qualitative)
              "q"
              "k")
        next-num (inc (apply max 0 separator-nums))]
    (keyword "separator" (str sep next-num))))

(defn add-group-heading!
  [type category ordering]
  (let [new-el (new-separator-kw type ordering)
        new-ordering (vec (concat ordering [new-el]))]
    (swap! db/ordering assoc type new-ordering)
    (-> (conn/sendp! :kpi-category/reorder
                     {:category-id (:db/id category)
                      :type        type
                      :ordering    new-ordering})
        (p/then (fn [_]
                  ;;set a timer that empties local state
                  ;; (so that subscription updates are reflected in frontend)
                  (let [old-timer @db/timer]
                    (when old-timer
                      (js/clearTimeout old-timer))
                    (reset! db/timer
                      (js/setTimeout (fn [_]
                                       (swap! db/ordering dissoc type)
                                       (reset! db/timer nil))
                                     2000)))))
        (p/catch (fn [e]
                   (swap! db/ordering dissoc type)
                   (logging/error "Failed to add kpi-category group heading" e))))))

(defn remove-group-heading!
  [type category kw]
  (let [ordering (or (get @db/ordering type)
                     (-> category
                         :kpi-category/ordering
                         type))
        new-ordering (->> ordering
                          (remove #{kw})
                          vec)]
    (swap! db/ordering assoc type new-ordering)
    (-> (conn/sendp! :kpi-category/reorder
                     {:category-id (:db/id category)
                      :type        type
                      :ordering    new-ordering})
        (p/then (fn [_]
                  ;;remove group heading title from user-guidances
                  (conn/sendp! :kpi-category/update-user-guidance
                               {:category-id (:db/id category)
                                :kw          kw
                                :guidance    ""})

                  ;;set a timer that empties local state
                  ;; (so that subscription updates are reflected in frontend)
                  (let [old-timer @db/timer]
                    (when old-timer
                      (js/clearTimeout old-timer))
                    (reset! db/timer
                      (js/setTimeout (fn [_]
                                       (swap! db/ordering dissoc type)
                                       (reset! db/timer nil))
                                     2000)))))
        (p/catch (fn [e]
                   (swap! db/ordering dissoc type)
                   (logging/error "Failed to remove kpi-category group heading" e))))))

;;remove member from non-finished category (in wizard/creator)
(defn remove-member!
  [member]
  (entity-actions/*->disable!
   (:db/id member)
   (fn [_])
   (fn [e] (logging/error "Failed to remove kpi member" e))))

(defn selected-category
  []
  (let [category-id (-> @db/state
                        :selected-category)]
    (get @db/session-entities category-id)))

(defn select-category!
  [category-id]
  (swap! db/state assoc :selected-category category-id))

(defn open-company-reports!
  [company category]
  (when (and company category)
    (routing/set-view! [:kpi-company-reports :id (:db/id company)] {:category category})))

(defn add-report!
  [cycle company on-success! on-error!]
  (let [msg {:cycle-id (:db/id cycle)
             :asset-id (:db/id company)}]
    (kpi-category-actions/*->add-report!
     msg
     (when on-success!
       on-success!)
     (when on-error!
       on-error!))))

(defn start-creator!
  []
  (swap! db/creator-state assoc :show? true))

(defn abort-category!
  [category]
  (let [msg {:category-id (:db/id category)}]
    (swap! db/wizard-state assoc :processing? true)
    (swap! db/creator-state assoc :processing? true)
    (kpi-category-actions/*->abort!
     msg
     (fn [_]
       (js/setTimeout (fn [_]
                        (swap! db/state dissoc :wizard :creator)
                        2000)))
     (fn [e]
       (logging/error "Failed to abort kpi category" e)
     ))))

(defn start-add-company!
  [category members]
  (modals/open-modal!
   kpi-member-curtain/modal-key
   {:target  category
    :members members
    :invite? true}))

(defn open-settings!
  []
  (swap! db/settings-state assoc :show? true))

(defn exit-settings!
  []
  (reset! db/settings-state nil))

(defn view-ad!
  []
  (analytics/event "kpi-ad-viewed")
  (kpi-category-actions/*->view-ad!
   {}
   (fn [_]
     (logging/info "Sent kpi-ad-viewed")
   )
   (fn [e]
     (logging/error "Failed to update kpi-ad-seen-on" e)
   )))

(defn remove-cycle!
  [cycle-id]
  (entity-actions/*->disable! cycle-id
                              identity
                              error-utils/show-error!))

(defn start-remove-cycle!
  [cycle-id]
  (modals/open-modal!
   confirmation-modal/modal-key
   {:body           (loc/tr :kpi-category/confirm-cycle-remove)
    :confirm-text   (loc/tr :delete)
    :confirm-icon   ""
    :skip-checkbox? true
    :on-confirm     #(remove-cycle! cycle-id)}))

;;removing a member from a finished category:
(defn remove-category-member!
  [member-id]
  (kpi-category-actions/*->disable-member!
   {:member-id member-id}
   (fn [_])
   (fn [e] (logging/error "Failed to remove kpi member" e))))

(defn start-remove-member!
  [member-id]
  (modals/open-modal!
   confirmation-modal/modal-key
   {:body          (loc/tr :kpi-category/confirm-member-remove-long)
    :confirm-text  (loc/tr :delete-permanently-no-undo)
    :checkbox-text (loc/tr :kpi-category/remove-member-confirmation)
    :confirm-icon  ""
    :on-confirm    #(remove-category-member! member-id)}))

;;removing the whole category
(defn remove-category!
  [category]
  (kpi-category-actions/*->remove-category!
   {:category-id (:db/id category)}
   (fn [_]
     (exit-settings!))
   (fn [e] (logging/error "Failed to remove kpi category" e))))

(defn start-remove-category!
  [category]
  (modals/open-modal!
   confirmation-modal/modal-key
   {:body          (loc/tr :kpi-category/confirm-category-remove-long)
    :confirm-text  (loc/tr :delete-permanently-no-undo)
    :checkbox-text (loc/tr :kpi-category/remove-category-confirmation)
    :confirm-icon  ""
    :on-confirm    #(remove-category! category)}))

(defn get-report
  [cycle company]
  (let [cycle-id (:db/id cycle)
        company-id (:db/id company)]
    (->> @session/all-kpi-reports
         (cu/only-entity :kpi-report/kpi-cycle cycle-id)
         (cu/only-entity :kpi-report/company company-id)
         (remove :common/disabled?)
         (first))))

(defn get-companies-reports
  [cycle]
  (let [category-id (->> cycle
                         :kpi-cycle/kpi-category)
        members (->> @session/all-kpi-members
                     (cu/only-entity :kpi-member/target category-id)
                     (remove :common/disabled?))
        companies (->> members
                       (map :kpi-member/asset)
                       (keep (fn->> (get @session/entities)))
                       (remove :common/disabled?)
                       (sort-by (fn->> :asset/name str string/trim string/lower-case)))]
    (->> companies
         (map (fn [company]
                [company (get-report cycle company)]))
         (remove (fn [[company report]]
                   (nil? report))))))

(defn empty-cycle?
  [cycle]
  (->> cycle
       get-companies-reports
       empty?))

(defn export-cycle
  [cycle]
  (let [companies-reports (get-companies-reports cycle)
        data (->> companies-reports
                  (map (fn [[company report]]
                         (concat [[(:asset/name company)]]
                                 (report-events/report-data report cycle)))))]
    (excel/export-multiple-sheet-array-data (loc/tr :export-filename-kpi-report
                                                [(:kpi-cycle/name cycle) (loc/tr :full-cycle)])
                                            data)))
